export default __webpack_public_path__ + "static/media/5.a22251a1.png";